// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { RELATED_PARTY_RELATIONSHIP } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPGLoan,
  IsApplicantSameAsPrincipal,
  RelatedPartyRelationshipEqualsTo,
} from '../rules';

class PgFiledTaxes1YearAgoRuleset implements Ruleset {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isPGLoan = IsPGLoan.evaluate(data);
    const applicantSameAsPrincipal = IsApplicantSameAsPrincipal.setPrincipalId(
      this.principalId
    ).evaluate(data);

    const rpRelationshipIsPrincipal =
      RelatedPartyRelationshipEqualsTo.setPrincipalId(this.principalId)
        .setRelationship(RELATED_PARTY_RELATIONSHIP.PRINCIPAL)
        .evaluate(data);

    return isPGLoan && applicantSameAsPrincipal && rpRelationshipIsPrincipal
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  };
}

export default new PgFiledTaxes1YearAgoRuleset();
